import React from "react";

interface TagProps {
  tagType?: "primary" | "secondary";
  title: string;
  prefixIcon?: string | React.ReactNode;
  suffixIcon?: string | React.ReactNode;
  className?: string;
  isSelected?: boolean;
  titleColor?: string;
}

const Tag: React.FC<TagProps> = ({
  tagType = "primary",
  title,
  prefixIcon,
  titleColor,
  suffixIcon,
  isSelected = false,
  className = "tag-wrapper flex gap-2 items-center justify-center font-inter text-sm font-medium px-1 py-0.5 rounded-md border",
}) => {
  return (
    <span className={(className) + (tagType === "primary" ? " bg-[#F0F9FF] border-[#B9E6FE] primary-tag text-primary-tag" : "bg-[#F9FAFB] border-[#E4E7EC] secondary-tag text-text-secondary")}>
      <span className="tag-prefix-icon">
        {prefixIcon}
      </span>
      <span className={`tag-title ${titleColor}`}>{title}</span>
      <span className={`tag-suffix-icon transition-all ${isSelected ? "rotate-45" : ""}`}>
        {suffixIcon}
      </span>
    </span>
  );
};

export default Tag;
